module.exports = __webpack_public_path__ + "media/instanieuwsuur_HetNieuweGamenV6.0d690e76.mp4";